export default __webpack_public_path__ + "static/media/5.e36c1f53.JPG";